//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
let d=[[[0,"OrderState",0,0],[0,"OrderType",0,0]],[[[],"GetReversed",{R_:{isReversed:''}},0,0],[["isReversed"],"SetReversed",{},1,0],[[],"Activate",{},0,0],[[],"Delete",{},0,0],[[],"Save",{},0,0],[["newName"],"SaveAs",{R_:{newOrder:"Assemblies.Order"}},1,0],[["parent","numberOfChildren","children"],"GetChildrenOrder",{},1,1],[[],"IsActive",{R_:{isActiveOrder:''}},0,0],[["useSubAssemblyOrder"],"SetUseSubAssemblyOrder",{},1,0],[[],"CanUseSubAssemblyOrder",{R_:{useSubAssemblyOrder:''}},0,0]],[]];
SPLM.Assemblies.Order = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.Order";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.Order.State = Object.freeze({
    "UnSaved" : "UnSaved", "Saved" : "Saved"});

SPLM.Assemblies.Order.Type = Object.freeze({
    "UserDefinedComponent" : "UserDefinedComponent", "SequentialComponent" : "SequentialComponent", "ChronologicalComponent" : "ChronologicalComponent", "AlphanumericComponent" : "AlphanumericComponent", "AlphabeticComponent" : "AlphabeticComponent"});

export default SPLM;